var loginMain = require('./login.js');
var MyDevice = require("../../../cloudflow/PWA/js/Device.js");

$(function () {
    loginMain.loginStart();

    MyDevice.init();
});